
<f-dialog
    v-model      = "show"
    :title       = "title"
    :width       = "600"
    :show-header = "false"
    :show-delete = "false"

    store-label  = "Zuordnen"
    @store       = "onAssign"
    @cancel      = "onCancel"
>
    <template v-slot:content>
        <div style="width: calc(100% + 10px)">
            <c-card-iterator
                v-if           = "contacts"
                :items         = "contacts"
                :item-height   = "50"
                :label         = "title"
                :filter        = "contactFilter"
                class          = "w-100"
                :height        = "480"
                ref            = "iterator"
            >
                <template v-slot:filter>
                    <v-row class="no-frame">
                        <v-col class="no-frame">
                            <f-enum-autocomplete
                                v-if       = "onsite"
                                v-model    = "onSitecompany"
                                label      = "Facility Manager"
                                module     = "msd"
                                type       = "facilitymanager"
                                :clearable = "true"
                                @change    = "onCompany"
                            />
                            <f-enum-autocomplete
                                v-if       = "zus"
                                v-model    = "zuscompany"
                                label      = "ZÜS"
                                module     = "msd"
                                type       = "zus"
                                :clearable = "true"
                                @change    = "onCompany"
                            />
                        </v-col>
                    </v-row>
                </template>
                <template v-slot:card="{ item }">
                    <c-list-card
                        :height      = "55"
                        :background  = "item.background"
                        :edit        = "false"
                        border-width = "pa-2 pt-1"
                        :key         = "item.id + item.selected"
                        @selected    = "onSelected(item)"
                    >
                        <template v-slot:title>
                            <div class="v-flex w-100">
                                <div class="contact-data">
                                   {{ item.firstname ? (item.firstname + ' ' + item.name) : item.name}}
                                </div>
                                <v-spacer />
                                <div class="contact-data">
                                    {{ item.email }}
                                </div>
                            </div>
                        </template>
                        <template v-slot:body>
                            <div class="v-flex">
                                <div class="contact-data">
                                    {{ roles (item) }}
                                </div>
                                <v-spacer />
                                <div class="contact-data">
                                    {{ phones (item) }}
                                </div>
                            </div>
                        </template>
                    </c-list-card>
                </template>
            </c-card-iterator>
        </div>
    </template>
</f-dialog>
